import {
  colors,
  type IconName,
  Tag,
  type TagVariant,
} from '@dev-spendesk/grapes';
import {
  BaseEdge,
  EdgeLabelRenderer,
  type EdgeProps,
  getSmoothStepPath,
  Position,
} from '@xyflow/react';

import { useWorkflowContext } from '../../state/WorkflowContext';

export type EdgeData = {
  labelText: string;
  labelVariant: TagVariant | 'blank';
  direction?: 'horizontal' | 'vertical';
  icon?: IconName;
};

type Props = EdgeProps & {
  data: EdgeData;
};

export const LabelEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data: { labelText, labelVariant, direction = 'horizontal', icon },
  markerEnd,
}: Props) => {
  const { pathEdgeIds } = useWorkflowContext();
  const isInPath = pathEdgeIds.has(id);
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 20,
    ...(direction === 'horizontal'
      ? {
          sourcePosition: Position.Right,
          targetPosition: Position.Left,
        }
      : {
          sourcePosition: Position.Bottom,
          targetPosition: Position.Top,
        }),
  });

  const endLabelX = targetX - (direction === 'horizontal' ? 55 : 0);
  const endLabelY = targetY - (direction === 'horizontal' ? 0 : 55);

  return (
    <>
      <BaseEdge
        style={{
          stroke: isInPath
            ? colors.contentBrandDefault
            : colors.contentDisabled,
          strokeWidth: isInPath ? 2 : 1,
        }}
        id={id}
        markerEnd={markerEnd}
        path={edgePath}
      />
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${endLabelX}px, ${endLabelY}px)`,
            pointerEvents: 'all',
          }}
        >
          {labelVariant === 'blank' ? (
            <div className="bg-background-primary-default text-content-primary title-s rounded px-8 py-4">
              {labelText}
            </div>
          ) : (
            <Tag iconName={icon} variant={labelVariant}>
              {labelText}
            </Tag>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
